import { defineMessages } from 'react-intl-next';

import { useObjectSidebar } from '@confluence/object-sidebar-api';

import { JiraWorkItemsPanelBody } from '../components/JiraWorkItemsPanelBody';
import { JiraWorkItemsPanelIcon } from '../components/JiraWorkItemsPanelIcon';

export const i18n = defineMessages({
	jiraWorkItemsPanelHeaderLabel: {
		id: 'details-panel.jira-work-items.header.label',
		defaultMessage: 'Jira work items',
		description: 'Label for the details panel header',
	},
});

export const useShowJiraWorkItemsPanel = () => {
	const [{ isObjectSidebarShown, panel }, { showObjectSidebar }] = useObjectSidebar();
	const panelId = 'jiraWorkItemsPanel';
	const showJiraWorkItemsPanel = () => {
		showObjectSidebar(
			{
				id: panelId,
				headerComponentElements: {
					HeaderIcon: JiraWorkItemsPanelIcon,
					headerLabel: i18n.jiraWorkItemsPanelHeaderLabel,
				},
				// Todo: implement this in CBT-4867 (https://hello.jira.atlassian.cloud/browse/CBT-4867)
				BodyComponent: JiraWorkItemsPanelBody,
			},
			'push',
		);
	};
	return {
		isJiraWorkItemsPanelShown: isObjectSidebarShown && panel?.id === panelId,
		showJiraWorkItemsPanel,
	};
};
